import { ReactNode } from 'react';

interface PageHeaderProps {
  title: string;
  description?: string;
  children?: ReactNode;
}

export function PageHeader({ title, description, children }: PageHeaderProps) {
  return (
    <div className="mb-8 flex flex-col items-center justify-between gap-4 border-b pb-6 md:flex-row">
      <div className="flex flex-col gap-1 text-center md:text-start">
        <h1 className="text-xl font-bold text-gray-950">{title}</h1>
        {description && <p className="text-foreground">{description}</p>}
      </div>
      {children}
    </div>
  );
}
